import apiInstance from "@/axios";

let names = null;

/**
 * 승인 운영자 이름 찾기(M1). 예외 정보(C1·C7)의 approvedBy 는 운영자 계정 id 만 오므로
 * 이미 있는 운영자 목록 API(GET /accounts/certilife)로 { id: "이름(아이디)" } 표를 만든다.
 * 실패하면 빈 표(호출하는 쪽은 id 를 그대로 보임)이고 다음 호출에서 다시 읽는다.
 * ponytail: 한 번 읽어 페이지를 새로 열 때까지 쓴다. 운영자가 수백 명을 넘으면 서버가 approvedByName 을 주게.
 */
export const loadOperatorNames = () => {
  if (!names) {
    names = apiInstance
      .get("/accounts/certilife", { params: { page: 1, limit: 500 }, showGlobalLoading: false })
      .then(({ data }) =>
        Object.fromEntries(
          ((data && data.docs) || []).map((a) => [
            String(a._id),
            a.name ? `${a.name}(${a.username})` : a.username,
          ])
        )
      )
      .catch((error) => {
        console.error(error);
        names = null;
        return {};
      });
  }
  return names;
};
